window.initBymoqaLight = function(app){

    const header = app.header;

    app.pointer = {

        x: header.offsetWidth / 2,
        y: header.offsetHeight / 2,
        inside: false

    };

    header.addEventListener("mouseenter",()=>{

        app.pointer.inside = true;

    });

    header.addEventListener("mouseleave",()=>{

        app.pointer.inside = false;

    });

    header.addEventListener("mousemove",(e)=>{

        const rect = header.getBoundingClientRect();

        app.pointer.x = e.clientX - rect.left;
        app.pointer.y = e.clientY - rect.top;

    });

    /*
======================================================
Touch Support
======================================================
*/

header.addEventListener("touchstart",(e)=>{

    app.pointer.inside = true;

    const touch = e.touches[0];
    const rect = header.getBoundingClientRect();

    app.pointer.x = touch.clientX - rect.left;
    app.pointer.y = touch.clientY - rect.top;

},{passive:true});

header.addEventListener("touchmove",(e)=>{

    const touch = e.touches[0];
    const rect = header.getBoundingClientRect();

    app.pointer.x = touch.clientX - rect.left;
    app.pointer.y = touch.clientY - rect.top;

},{passive:true});

header.addEventListener("touchend",()=>{

    app.pointer.inside = false;

},{passive:true});

}